import { He6UltraDeviceList } from '@/define/device_vendor'
import { deviceManager } from './device_manager'

export abstract class DeviceProtocolBase {
  abstract connect(): Promise<boolean>
  abstract send(data: number[]): void
  abstract sendFeature(data: number[]): void
  abstract onReceive(fn: (data: number[]) => void): void
}

interface QueuePromiss {
  resolve: (value: number[] | PromiseLike<number[]>) => void
  reject: (reason?: any) => void
  arguments: number[]
  isSendFeature: boolean
  haveResult: boolean
}

export class DeviceProtocol {
  public deviceHID: DeviceProtocolBase | null = null

  private answerPromiss: Promise<number[]> | null = null
  private answerResolve: (value: number[] | PromiseLike<number[]>) => void = () => {}

  private queue: QueuePromiss[] = []
  private processing = false

  private reciveAny1 = (_: number[]) => {}

  public onReciveAny(fn: (data: number[]) => void) {
    this.reciveAny1 = fn
  }

  constructor() {
    // this.deviceModel = new he3Model(this);
  }

  private async processQueue(): Promise<void> {
    if (this.processing) return
    this.processing = true

    while (this.queue.length > 0) {
      const task = this.queue.shift()
      if (task) {
        if (this.deviceHID) {
          this.answerPromiss = new Promise((resolve) => {
            this.answerResolve = resolve
          })
          if (task.isSendFeature) {
            await this.deviceHID.sendFeature(Array.from(task.arguments))
          } else {
            await this.deviceHID.send(Array.from(task.arguments))
          }
          if (task.haveResult == false) {
            task.resolve([])
            this.answerPromiss = null
            continue
          }
          let res = await this.answerPromiss
          task.resolve(res)
          this.answerPromiss = null
        } else {
          task.reject('device not connected')
        }
      }
    }

    this.processing = false
  }

  send(data: number[], isSendFeature = false, haveResult = true): Promise<number[]> {
    return new Promise((resolve, reject) => {
      this.queue.push({ resolve: resolve, reject: reject, arguments: data, isSendFeature: isSendFeature, haveResult: haveResult })
      this.processQueue()
    })
  }

  setBase = async (deviceHID: DeviceProtocolBase) => {
    this.deviceHID = deviceHID
    await this.deviceHID.connect()
    this.deviceHID.onReceive((data) => {
      if (this.answerPromiss) {
        if (He6UltraDeviceList.includes(deviceManager.deviceID) && data[0] == 0x0a) {
          return
        }
        this.answerResolve(data)
      }
      this.reciveAny1(data)
    })
  }

  disconnect = async () => {
    this.processing = false
    this.queue = []
    this.deviceHID = null
  }
}

export const deviceProtocol = new DeviceProtocol()
